import gsap from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin.js";
gsap.registerPlugin(ScrollToPlugin);

import {
  clearAllBodyScrollLocks,
  disableBodyScroll,
  enableBodyScroll,
} from "body-scroll-lock-upgrade";

import { loadRecaptchaOnce } from "./_recaptcha.mjs";

let menu_toggle = document.querySelectorAll(".lines-button");
let fixed_menu = document.querySelector(".fixed-menu");
let menu_physical;
let menu_scroll;
let menu_titles;
const side_contact = document.querySelector(".side-contact");
const site_header = document.querySelector(".site-header");
const top_banner = document.querySelector(".top-banner");
const popup_contact = document.querySelector(".contact-popup");
const open_popup_contact_buttons = document.querySelectorAll(
  ".open-popup-contact",
);
const open_contact_popup_event = new Event("open-contact-popup");
const close_contact_popup_event = new Event("close-contact-popup");

const close_contact_popup_button = document.querySelector(
  ".contact-popup__close",
);
const below_menu = document.querySelector(".fixed-menu__below-menu");

if (
  popup_contact &&
  open_popup_contact_buttons &&
  open_popup_contact_buttons.length >= 1
) {
  open_popup_contact_buttons.forEach((button) => {
    button.addEventListener("click", (e) => {
      e.preventDefault();
      loadRecaptchaOnce();
      gsap.to(popup_contact, { opacity: 1, duration: 0.5 });
      popup_contact.showModal();
      document.dispatchEvent(open_contact_popup_event);
    });
  });

  popup_contact.addEventListener("click", (e) => {
    if (!e.target.closest(".contact-popup__modal")) {
      header_close_popup_modal();
    }
  });

  if (close_contact_popup_button) {
    close_contact_popup_button.addEventListener("click", () => {
      header_close_popup_modal();
    });
  }
}

function header_close_popup_modal() {
  gsap.to(popup_contact, {
    opacity: 0,
    duration: 0.5,
    onComplete: () => {
      popup_contact.close();
      document.dispatchEvent(close_contact_popup_event);
    },
  });
}

let popup_contact_form = document.querySelector(".contact-popup__modal .wpcf7");

let popup_contact_form_inner = document.querySelector(
  ".contact-popup .contact-form",
);

if (popup_contact_form) {
  popup_contact_form.addEventListener(
    "wpcf7mailsent",
    function (event) {
      if (popup_contact_form_inner) {
        gsap.to(popup_contact_form_inner, {
          opacity: 0,
          duration: 0.5,
          onComplete: () => {
            gsap.set(popup_contact_form_inner, { display: "none" });
          },
        });
      }
      header_gtag_report_conversion();
      if (typeof fbq !== "undefined") {
        fbq("track", "Lead", {
          value: 1,
          currency: "CAD",
        });
      }
    },
    false,
  );
}

function header_gtag_report_conversion(url) {
  var callback = function () {
    if (typeof url != "undefined") {
      window.location = url;
    }
  };
  gtag("event", "conversion", {
    send_to: "AW-952809482/UVqZCMTV_NUZEIrwqsYD",
    event_callback: callback,
  });
  gtag("event", "conversion", {
    send_to: "AW-952809482/79QRCOfZlHwQivCqxgM",
    event_callback: callback,
  });
  return false;
}

function animateFixedHeader() {
  if (top_banner) {
    if (window.pageYOffset > top_banner.scrollHeight) {
      site_header.classList.add("fixed");
      site_header.classList.add("scrolled");
      document.querySelector("body").classList.add("scrolling");
    } else {
      site_header.classList.remove("fixed");
      site_header.classList.remove("scrolled");
      document.querySelector("body").classList.remove("scrolling");
    }
  } else {
    site_header.classList.add("fixed");
    document.querySelector("body").classList.add("scrolling");
    if (window.pageYOffset > 150) {
      site_header.classList.add("scrolled");
    } else {
      site_header.classList.remove("scrolled");
    }
  }
}

if (site_header) {
  animateFixedHeader();
  window.addEventListener("scroll", function () {
    if (!site_header.classList.contains("shrunk")) {
      animateFixedHeader();
    }
  });
}

if (fixed_menu) {
  menu_physical = fixed_menu.querySelector(".fixed-menu__physical");
  menu_scroll = fixed_menu.querySelector(".fixed-menu__padding");
  menu_titles = fixed_menu.querySelectorAll(".menu-item__title");
  menu_toggle.forEach((toggle) => {
    toggle.addEventListener("click", () => {
      if (!toggle.classList.contains("close")) {
        toggle.classList.add("close");
        if (site_header) {
          site_header.classList.add("shrunk");
          site_header.classList.add("menu-opened");
        }
        fixed_menu.style.display = "block";

        let header_position = site_header
          ? site_header.getBoundingClientRect().top
          : 0;
        let fixed_menu_top = header_position + 80;

        fixed_menu.style.top = `${fixed_menu_top}px`;

        gsap.to(menu_physical, { height: "100%", duration: 0.5 });

        let menu_titles_counter = 0;

        menu_titles.forEach((title, index) => {
          gsap.fromTo(
            title,
            { opacity: 0, x: -40 },
            {
              opacity: 1,
              x: 0,
              duration: 0.5,
              delay: menu_titles_counter * 0.1,
            },
          );
          menu_titles_counter++;
        });

        if (below_menu) {
          gsap.fromTo(
            below_menu.querySelectorAll("li"),
            { opacity: 0, x: -40 },
            {
              opacity: 1,
              x: 0,
              duration: 0.5,
              stagger: 0.1,
              delay: menu_titles_counter * 0.1,
            },
          );
        }

        disableBodyScroll(menu_scroll, { reserveScrollBarGap: true });
      } else {
        toggle.classList.remove("close");
        if (site_header) {
          site_header.classList.remove("shrunk");
          site_header.classList.remove("menu-opened");
        }
        gsap.to(menu_physical, {
          height: 0,
          duration: 0.5,
          onComplete: function () {
            fixed_menu.style.display = "none";
          },
        });
        enableBodyScroll(menu_scroll);
      }
    });
  });
}

if (document.body.classList.contains("page-template-template-landing")) {
  const go_to_form_buttons = document.querySelectorAll(".go-to-form");
  const landing_form = document.querySelector(".landing-hero__form");

  if (go_to_form_buttons.length && landing_form) {
    go_to_form_buttons.forEach((button) => {
      button.addEventListener("click", (e) => {
        e.preventDefault();

        const pulse = () => {
          gsap
            .timeline()
            .to(landing_form, { scale: 1.05, duration: 0.2 })
            .to(landing_form, { scale: 1, duration: 0.2 })
            .to(landing_form, { scale: 1.05, duration: 0.2 })
            .to(landing_form, { scale: 1, duration: 0.2 });
        };

        const rect = landing_form.getBoundingClientRect();
        const in_viewport = rect.top >= 0 && rect.top < window.innerHeight / 2;

        if (in_viewport) {
          pulse();
        } else {
          gsap.to(window, {
            scrollTo: { y: landing_form, offsetY: 150 },
            duration: 1,
            onComplete: pulse,
          });
        }
      });
    });
  }
}
